/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthWizardStage } from './PalAuthWizardStage';
import {
    PalAuthWizardStageFromJSON,
    PalAuthWizardStageFromJSONTyped,
    PalAuthWizardStageToJSON,
    PalAuthWizardStageToJSONTyped,
} from './PalAuthWizardStage';

/**
 * 
 * @export
 * @interface ReviewPalAuthSubmissionRequest
 */
export interface ReviewPalAuthSubmissionRequest {
    /**
     * Payor ID (required for automated review)
     */
    payor_id?: string;
    /**
     * Auth platform ID (required for automated review)
     */
    auth_platform_id?: string;
    /**
     * Whether this is a non-submission flow
     */
    is_non_submission_flow?: boolean;
    /**
     * Optional override for review mode. 'efax' prepares the PAL submission for fax delivery without selecting a payer portal form.
     */
    submission_mode?: ReviewPalAuthSubmissionRequestSubmissionModeEnum;
    /**
     * Required when submission_mode is efax. Normalized destination fax number to persist on the PAL submission during review.
     */
    destination_fax_number?: string;
    /**
     * 
     */
    include_lead_summary_report?: boolean;
    /**
     * 
     */
    wizard_stage?: PalAuthWizardStage;
}


/**
 * @export
 */
export const ReviewPalAuthSubmissionRequestSubmissionModeEnum = {
    Efax: 'efax',
} as const;
export type ReviewPalAuthSubmissionRequestSubmissionModeEnum = typeof ReviewPalAuthSubmissionRequestSubmissionModeEnum[keyof typeof ReviewPalAuthSubmissionRequestSubmissionModeEnum];


/**
 * Check if a given object implements the ReviewPalAuthSubmissionRequest interface.
 */
export function instanceOfReviewPalAuthSubmissionRequest(value: object): value is ReviewPalAuthSubmissionRequest {
    return true;
}

export function ReviewPalAuthSubmissionRequestFromJSON(json: any): ReviewPalAuthSubmissionRequest {
    return ReviewPalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function ReviewPalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewPalAuthSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'payor_id': json['payor_id'] == null ? undefined : json['payor_id'],
        'auth_platform_id': json['auth_platform_id'] == null ? undefined : json['auth_platform_id'],
        'is_non_submission_flow': json['is_non_submission_flow'] == null ? undefined : json['is_non_submission_flow'],
        'submission_mode': json['submission_mode'] == null ? undefined : json['submission_mode'],
        'destination_fax_number': json['destination_fax_number'] == null ? undefined : json['destination_fax_number'],
        'include_lead_summary_report': json['include_lead_summary_report'] == null ? undefined : json['include_lead_summary_report'],
        'wizard_stage': json['wizard_stage'] == null ? undefined : PalAuthWizardStageFromJSON(json['wizard_stage']),
    };
}

export function ReviewPalAuthSubmissionRequestToJSON(json: any): ReviewPalAuthSubmissionRequest {
    return ReviewPalAuthSubmissionRequestToJSONTyped(json, false);
}

export function ReviewPalAuthSubmissionRequestToJSONTyped(value?: ReviewPalAuthSubmissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payor_id': value['payor_id'],
        'auth_platform_id': value['auth_platform_id'],
        'is_non_submission_flow': value['is_non_submission_flow'],
        'submission_mode': value['submission_mode'],
        'destination_fax_number': value['destination_fax_number'],
        'include_lead_summary_report': value['include_lead_summary_report'],
        'wizard_stage': PalAuthWizardStageToJSON(value['wizard_stage']),
    };
}

